import React, { useState } from "react";
import "./OrderTable.scss";
import CommonTable from "../../../../components/common/CommonTable/CommonTable.jsx";
import { ATS } from "../../../../features/ats/atsSlice";
import { refreshActivePairBalance } from "../../../../services/wallet/tradeBalanceRefresh.service";
import { parseJSON, toFix } from "../../../../helpers/commonHelper";
import { Button } from "react-bootstrap";
import ButtonTriangleSpinner from "../../../../components/common/ButtonTriangleSpinner/ButtonTriangleSpinner.jsx";
import moment from "moment";
import { CancelOrderConfirmationModal } from "../../../../components/common/commonModal/CandelOrderConfirmationModal/CandelOrderConfirmationModal.jsx";
import { useDispatch, useSelector } from "react-redux";
import { getLinkedWalletAddress, isNonCustodialWallet } from "../../../../services/wallet/linkedWallet.utils";
import { reconcileDvpAllowanceAfterCancel } from "../../../../services/wallet/nonCustodialDvpOrder.service";
import { getNonCustodialWeb3Session } from "../../../../services/wallet/nonCustodialSession";
import { removeCachedOpenOrder } from "../../../../services/wallet/openOrdersCache.service";
import { toastMsg } from "../../../../components/common/Toast/Toast";
import { formatOrderWalletTypeLabel } from "../OrderHistory/orderHistoryMerge";
import { buildAllowanceApprovalToastMessage } from "../../../../services/wallet/allowanceApprovalMessaging";
const OrderTable = ({
  dataList,
  selectedPair,
  onLoadMore,
  loadMore,
  isListFetching,
  loadMoreFetching
}) => {
  const dispatch = useDispatch();
  const selectedTradeWallet = useSelector(state => state.ats.selectedTradeWallet);
  const [selectedIndex, setSelectedIdex] = useState(-1);
  const [showModal, setShowModal] = useState(false);
  const [isSubmitted, setIsSubmited] = useState(false);
  const [modalData, setModalData] = useState(null);
  const fields = ["Symbol", "Price", "Quantity", "Side", "Order Type", "Wallet Type", "Filled Amount", "Executed Price", "Status", "Expiry Date", "Created Date", "Action"];
  const showLoadMoreFooter = loadMoreFetching || Boolean(loadMore) && !isListFetching;
  const onCanceOrder = async orderId => {
    setIsSubmited(true);
    const cancelledOrder = modalData ? parseJSON(modalData) : null;
    if (selectedTradeWallet && isNonCustodialWallet(selectedTradeWallet) && cancelledOrder) {
      const web3 = getNonCustodialWeb3Session();
      const ownerAddress = getLinkedWalletAddress(selectedTradeWallet);
      if (web3 && ownerAddress) {
        try {
          await reconcileDvpAllowanceAfterCancel({
            web3,
            wallet: selectedTradeWallet,
            ownerAddress,
            cancelledOrder,
            fallbackPair: selectedPair,
            onApprovalTxRequested: approvalCtx => {
              toastMsg.info(buildAllowanceApprovalToastMessage({
                ...approvalCtx,
                mode: approvalCtx?.mode || "set"
              }));
            }
          });
        } catch (error) {
          toastMsg.error(error?.message || "Order cancelled, but allowance could not be updated in MetaMask.");
        }
      }
    }
    const response = await ATS.cancelUserOrder({
      pairName: selectedPair?.pair_key,
      orderId
    });
    if (response.status === 200) {
      removeCachedOpenOrder(selectedPair?.pair_key, orderId);
      setIsSubmited(false);
      setShowModal(false);
      setSelectedIdex(-1);
      await refreshActivePairBalance(dispatch, {
        selectedPair,
        selectedTradeWallet
      });
      window.dispatchEvent(new CustomEvent("open-orders:refresh", {
        detail: {
          pairName: selectedPair?.pair_key
        }
      }));
      window.dispatchEvent(new CustomEvent("order-books:refresh", {
        detail: {
          pairName: selectedPair?.pair_key
        }
      }));
    } else {
      setIsSubmited(false);
      setSelectedIdex(-1);
    }
  };
  const onSelectOrderCancel = order => {
    const obj = parseJSON(order);
    obj.pairName = selectedPair.pair_key;
    // obj.name = selectedPair?.name || '';
    obj.pair_key = `${selectedPair.otherCurrency}/${selectedPair.baseCurrency}`;
    setModalData(obj);
    setShowModal(true);
  };
  const handleCloseModal = async (request, isCancel) => {
    if (!isCancel) return setShowModal(false);
    const order = parseJSON(request);
    await onCanceOrder(order.id);
  };
  return <>
            <div className="orderTable">
                <CommonTable fields={fields}>
                    {dataList?.map((item, index) =>
        // (item['isCancel'] = false),

        <tr key={index}>
                                    <td>{`${selectedPair?.otherCurrency?.toUpperCase()}/${selectedPair?.baseCurrency?.toUpperCase()}`}</td>
                                    {/* <td>{`${selectedPair?.name?.toUpperCase()}`}</td> */}
                                    <td>{item.price}</td>
                                    <td>
                                        {item.quantity}
                                    </td>
                                    <td>
                                        <span className={item.side === 0 ? "green_text" : "red_text"}>
                                            {item.side === 0 ? 'Buy' : 'Sell'}
                                        </span>
                                    </td>
                                    <td>
                                        <span>{item.type === 0 ? "LIMIT" : "Market"}</span>
                                        <span>&nbsp;({item.advanceOrderType})</span>
                                    </td>
                                    <td>{formatOrderWalletTypeLabel(item)}</td>
                                    <td>{item.filled_amount}</td>
                                    <td>{item.executed_price}</td>
                                    <td>
                                        {item?.status === 1 && <p className="yellow_text">Pending</p>}
                                        {item?.status === 3 && <p className="green_text">Completed</p>}
                                        {item?.status === 4 && <p className="green_text">
                                                Partial (
                                                {toFix(item.filled_amount / item.quantity * 100, 1)}%)
                                            </p>}
                                        {item?.status === 2 && <p className="red_text">Cancelled </p>}
                                    </td>
                                    <td>
                                        {item.advanceOrderType === 'GTD' || item.advanceOrderType === 'DAY' ? item?.isFromSocket ? moment(item.expired_at).format('DD/MM/YYYY hh:mm A') : moment.utc(item.expired_at).format('DD/MM/YYYY hh:mm A') : "--"}
                                    </td>

                                    <td>{moment(item.created_at).format('DD/MM/YYYY HH:mm A')}</td>
                                    <td>
                                        <Button className="" onClick={() => onSelectOrderCancel(item)} size="sm" disabled={selectedIndex === index} type="button">Cancel</Button>
                                    </td>
                                </tr>)}
                </CommonTable>
                {showLoadMoreFooter ? <div className="tableLoaderBtn">
                        <button className="btn-style black-btn tableLoaderBtn__action w-100" disabled={isListFetching || !loadMore} onClick={onLoadMore} type="button" aria-busy={Boolean(loadMoreFetching)}>
                            <span className="tableLoaderBtn__label">
                                {loadMoreFetching ? 'Loading' : 'Load More'}
                            </span>
                            {loadMoreFetching ? <span className="tableLoaderBtn__spinner-inline" aria-hidden="true">
                                    <ButtonTriangleSpinner size={18} />
                                </span> : null}
                        </button>
                    </div> : null}
            </div>
            <CancelOrderConfirmationModal show={showModal} handleClose={handleCloseModal} data={modalData} isSubmitted={isSubmitted} />
        </>;
};
export default OrderTable;